import { useAuth } from '..';
import { storage, storageKeys, useStorage } from './use-storage';

export const useTerminatePurchaseProcess = () => {
  const { clearToken } = useAuth();
  const [, setPlanId] = useStorage(storage.SESSION, storageKeys.PROMO_PLAN_ID);
  const [, setSubscriptionId] = useStorage(
    storage.SESSION,
    storageKeys.SUBSCRIPTION_ID
  );
  const [, setSummary] = useStorage(
    storage.SESSION,
    storageKeys.SUMMARY_PRICES
  );
  const [, setPayload] = useStorage(
    storage.SESSION,
    storageKeys.SUMMARY_PAYLOAD
  );
  const [, setAppliedPromoCodes] = useStorage(
    storage.SESSION,
    storageKeys.PROMO_CODES
  );
  const [, setPlanSettings] = useStorage(
    storage.SESSION,
    storageKeys.PLAN_SETTINGS
  );

  const terminate = () => {
    setPlanId(undefined);
    setSubscriptionId(undefined);
    setSummary(undefined);
    setPayload(undefined);
    setAppliedPromoCodes(undefined);
    setPlanSettings(undefined);
    clearToken();
  };

  return { terminate };
};
